/*
 *
 * Ribbon
 *
 */

import React, { useEffect } from 'react';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import CabinetRibbon from './CabinetRibbon';
import TabNames from 'containers/Header/TabNames';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/Ribbon/ShelvesRibbon/types';
import { makeSelectActiveTab } from 'containers/Header/selectors';
import { useSelector, useDispatch } from 'react-redux';
import ShelvesRibbon from 'containers/Ribbon/ShelvesRibbon';
import OptionsRibbon from 'containers/Ribbon/OptionsRibbon';
import styled from 'styled-components/macro';
import { makeSelectDisplayFurniturePanel } from '../FurniturePanel/selectors';
import { useMedia } from 'use-media';
import { updateTabDisplayedAction } from '../Header/actions';

interface StateProps {
  activeTab: TabNames;
  isHide: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  activeTab: makeSelectActiveTab(),
  isHide: makeSelectDisplayFurniturePanel(),
});

const Ribbon = () => {
  useInjectReducer({ key: 'ribbon', reducer: reducer });
  const { activeTab, isHide } = useSelector(stateSelector);
  const isMobile = useMedia({ maxWidth: 1023 });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateTabDisplayedAction(activeTab));
  }, [activeTab]);

  if (isHide && isMobile) return null;

  return (
    <RibbonContainerStyled>
      {activeTab === TabNames.cabinet && <CabinetRibbon />}
      {activeTab === TabNames.shelves && <ShelvesRibbon />}
      {activeTab === TabNames.options && <OptionsRibbon />}
    </RibbonContainerStyled>
  );
};

export default Ribbon;

const RibbonContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${p => p.theme.secondary};
`;
